import { Injectable } from '@angular/core';
import {
  CartItem,
  CartOrder,
  EMPTY_MENU,
  MenuItem,
  RestaurantMenu,
} from './app.interface';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  private menu: RestaurantMenu = { ...EMPTY_MENU };
  private loadedRestaurantId = '';
  private order: CartOrder = {
    cart: [],
    note: '',
  };

  getData(): RestaurantMenu {
    return this.menu;
  }

  setData(menu: RestaurantMenu, restaurantId = ''): void {
    this.menu = menu;
    this.loadedRestaurantId = restaurantId;
  }

  hasMenuFor(restaurantId: string): boolean {
    return this.loadedRestaurantId === restaurantId;
  }

  getCart(): CartItem[] {
    return this.order.cart;
  }

  addToCart(item: MenuItem): string {
    const existingItem = this.existingItemInCart(item.id);
    const nextQuantity = (existingItem?.quantity ?? 0) + 1;
    if (
      item.availableQuantity !== null &&
      nextQuantity > item.availableQuantity
    ) {
      throw new Error(`Artikal "${item.title}" trenutno nije dostupan u toj količini.`);
    }
    if (existingItem) {
      existingItem.quantity = nextQuantity;
      return `Artikal "${item.title}" je dodat ${nextQuantity} puta.`;
    }
    this.order.cart.push({ ...item, quantity: 1 });
    return `Artikal "${item.title}" je uspješno dodat!`;
  }

  removeFromCart(item: CartItem): void {
    const existingItem = this.existingItemInCart(item.id);
    if (!existingItem) {
      return;
    }
    if (existingItem.quantity > 1) {
      existingItem.quantity--;
      return;
    }
    this.order.cart = this.order.cart.filter(
      (cartItem) => cartItem.id !== item.id
    );
  }

  clearOrder(): void {
    this.order = {
      cart: [],
      note: '',
    };
  }

  setNote(note: string): void {
    this.order.note = note.trim();
  }

  getNote(): string {
    return this.order.note;
  }

  getOrder(): CartOrder {
    return this.order;
  }

  getCartSum(): string {
    const sum = this.order.cart.reduce(
      (total, item) => total + item.quantity * item.price,
      0
    );
    return sum.toFixed(2);
  }

  private existingItemInCart(itemId: string): CartItem | undefined {
    return this.order.cart.find((cartItem) => cartItem.id === itemId);
  }
}
